import PropTypes from 'prop-types';
import Styles from './PortfolioRow.module.scss';

export default function PortfolioRow({ portfolios, openViewer }) {
  return (
    <div className={Styles.list}>
      {portfolios.map((portfolio, index) => {
        // if (portfolio.link) {
        //   return (
        //     <a
        //       key={index}
        //       className={Styles.itemLink}
        //       href={portfolio.link}
        //       target='_blank'
        //       rel='noopener noreferrer'>
        //       <img
        //         className={Styles.itemImage}
        //         src={portfolio.image}
        //         alt='Portfolio Item'
        //         key={index}
        //       />
        //     </a>
        //   );
        // }
        // return (
        //   <img key={index} src={portfolio.image} alt='Portfolio Item' className={Styles.item} />
        // );
        return (
          <div key={index} className={Styles.itemLink} onClick={() => openViewer(portfolio)}>
            <img
              loading='lazy'
              className={Styles.itemImage}
              height={'100px'}
              width={'150px'}
              src={portfolio.image}
              alt='Portfolio Item'
              key={index}
            />
          </div>
        );
      })}
      <div className={Styles.spacer} />
    </div>
  );
}

PortfolioRow.propTypes = {
  portfolios: PropTypes.arrayOf(PropTypes.object),
};
